<template lang="html">
  <div class="layout-private d-flex flex-column justify-content-between">


    <div class="header-private w-100 align-self-start">
      <div class="container">
        <div class="row row-title align-items-end">
          <div class="left-button">
            <button v-if="showBackBtn" @click="goBack" class="btn btn-sm btn-icon"><i class="far fa-angle-left"></i></button>
            <button v-if="showCancelBtn" @click="$emit('cancel')" class="btn btn-sm">Cancel</button>
          </div> <!-- /.left-button -->
          <div class="flex-grow-1 text-center">
            <p v-if="pageTitle" class="title">{{ pageTitle | limitStringLength(30) }}</p>
          </div> <!-- /.title -->
          <div class="right-button text-right">
            <button v-if="showShareBtn" @click="$emit('share')" class="btn btn-app btn-sm">Share</button>
          </div> <!-- /.right-button -->
        </div> <!-- /.row -->
      </div> <!-- /.container -->
    </div> <!-- /.header-private -->

    <div class="w-100 col-content flex-grow-1">
      <div class="container container-content">
        <div class="row row-content">
          <div class="col-override">
            <slot></slot>
          </div> <!-- /.col -->
        </div> <!-- /.row -->
      </div> <!-- /.container -->
    </div>

    <div class="footer-private w-100 align-self-end">
      <div class="container">
        <div class="row row-tabs text-center">
          <div class="col">
            <router-link to="/" class="nav-tab" exact-active-class="active">
              <!-- <img src="../assets/img/tab-icon-smiley.svg" alt="smiley" width="20px" height="20px"> -->
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20"><g transform="translate(-615.5 -370.382)"><path d="M625.5,390.382a10,10,0,0,1,0-20h.079a10,10,0,0,1-.079,20Zm0-18.462a8.425,8.425,0,1,0,.074,0Z" fill="#052b58"/><path d="M685.079,515.874a6.969,6.969,0,0,1-5.275,2.344,7.333,7.333,0,0,1-5.275-2.344.938.938,0,0,1,1.465-1.172,5.353,5.353,0,0,0,3.81,1.758,5.653,5.653,0,0,0,3.956-1.612.927.927,0,0,1,1.319-.147A1.093,1.093,0,0,1,685.079,515.874Z" transform="translate(-54.287 -132.862)" fill="#052b58"/></g></svg>
              <br />
              Activity
            </router-link>
          </div> <!-- /.col -->
          <div v-if="user && custom_claims && custom_claims.customerId && custom_claims.adminLevel" class="col">
            <router-link to="/stats" class="nav-tab" exact-active-class="active">
              <!-- <img src="../assets/img/tab-icon-stats.svg" alt="smiley" width="18px" height="15px"> -->
              <svg xmlns="http://www.w3.org/2000/svg" width="17.847" height="15.348" viewBox="0 0 17.847 15.348"><path d="M-8.708,1.079a.637.637,0,0,0,.183.477.659.659,0,0,0,.481.178H8.467a.661.661,0,0,0,.473-.191.629.629,0,0,0,.2-.473A.633.633,0,0,0,8.94.6a.653.653,0,0,0-.473-.2H-7.139A.205.205,0,0,1-7.371.174V-12.949a.644.644,0,0,0-.2-.465.633.633,0,0,0-.469-.2.642.642,0,0,0-.477.2.644.644,0,0,0-.2.465Zm.872-5.163L-2.5-7.172l3.843,3.3L8.176-7.944l-.523-.847L1.411-5.072-2.416-8.351l-5.42,3.129Zm5.229-1.967a1.43,1.43,0,0,0,.743-.2,1.5,1.5,0,0,0,.535-.535,1.43,1.43,0,0,0,.2-.743,1.43,1.43,0,0,0-.2-.743A1.471,1.471,0,0,0-1.864-8.8,1.454,1.454,0,0,0-2.606-9a1.454,1.454,0,0,0-.743.2,1.471,1.471,0,0,0-.535.531,1.43,1.43,0,0,0-.2.743,1.43,1.43,0,0,0,.2.743,1.5,1.5,0,0,0,.535.535A1.43,1.43,0,0,0-2.606-6.051ZM1.312-3a1.43,1.43,0,0,0,.743-.2,1.471,1.471,0,0,0,.531-.535,1.454,1.454,0,0,0,.2-.743,1.454,1.454,0,0,0-.2-.743,1.439,1.439,0,0,0-.531-.531,1.454,1.454,0,0,0-.743-.2,1.454,1.454,0,0,0-.743.2,1.471,1.471,0,0,0-.535.531,1.43,1.43,0,0,0-.2.743,1.43,1.43,0,0,0,.2.743A1.5,1.5,0,0,0,.569-3.2,1.43,1.43,0,0,0,1.312-3ZM7.57-6.782a1.43,1.43,0,0,0,.743-.2,1.5,1.5,0,0,0,.535-.535,1.43,1.43,0,0,0,.2-.743A1.43,1.43,0,0,0,8.849-9a1.5,1.5,0,0,0-.535-.535,1.43,1.43,0,0,0-.743-.2,1.43,1.43,0,0,0-.743.2A1.5,1.5,0,0,0,6.292-9a1.43,1.43,0,0,0-.2.743,1.43,1.43,0,0,0,.2.743,1.5,1.5,0,0,0,.535.535A1.43,1.43,0,0,0,7.57-6.782Z" transform="translate(8.708 13.613)" fill="#052b58"/></svg>
              <br />
              Stats
            </router-link>
          </div> <!-- /.col -->
          <div v-if="user && custom_claims && custom_claims.customerId" class="col">
            <router-link to="/rewards" class="nav-tab" exact-active-class="active">
              <!-- <img src="../assets/img/tab-icon-rewards.svg" alt="smiley" width="20px" height="20px"> -->
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20"><g transform="translate(-9822 3296)"><g transform="translate(9206.5 -3666.382)"><path d="M625.5,390.382a10,10,0,0,1,0-20h.079a10,10,0,0,1-.079,20Zm0-18.462a8.425,8.425,0,1,0,.074,0Z" fill="#052b58"/><path d="M685.079,515.874a6.969,6.969,0,0,1-5.275,2.344,7.333,7.333,0,0,1-5.275-2.344.938.938,0,0,1,1.465-1.172,5.353,5.353,0,0,0,3.81,1.758,5.653,5.653,0,0,0,3.956-1.612.927.927,0,0,1,1.319-.147A1.093,1.093,0,0,1,685.079,515.874Z" transform="translate(-54.287 -132.862)" fill="#052b58"/></g><g transform="translate(0.612 -1)"><path d="M-.28-4.2-.918-2.908-2.345-2.7a.313.313,0,0,0-.173.533l1.032,1.006L-1.729.26a.312.312,0,0,0,.453.329L0-.082,1.276.589A.313.313,0,0,0,1.729.26L1.485-1.161,2.518-2.167A.313.313,0,0,0,2.345-2.7L.918-2.908.28-4.2A.313.313,0,0,0-.28-4.2Z" transform="translate(9828 -3286)" fill="#052b58"/><path d="M-.28-4.2-.918-2.908-2.345-2.7a.313.313,0,0,0-.173.533l1.032,1.006L-1.729.26a.312.312,0,0,0,.453.329L0-.082,1.276.589A.313.313,0,0,0,1.729.26L1.485-1.161,2.518-2.167A.313.313,0,0,0,2.345-2.7L.918-2.908.28-4.2A.313.313,0,0,0-.28-4.2Z" transform="translate(9835 -3286)" fill="#052b58"/></g></g></svg>
              <br />
              Rewards
            </router-link>
          </div> <!-- /.col -->
          <div v-if="user && custom_claims && custom_claims.customerId && (custom_claims.customerId == user.uid || custom_claims.adminLevel == 'superAdmin')" class="col">
            <router-link to="/admin" class="nav-tab" exact-active-class="active">
              <!-- <img src="../assets/img/tab-icon-admin.svg" alt="smiley" width="18px" height="18px"> -->
              <svg xmlns="http://www.w3.org/2000/svg" width="17.764" height="17.747" viewBox="0 0 17.764 17.747"><path d="M-.623,2.88H1.054a1.3,1.3,0,0,0,.826-.27,1.263,1.263,0,0,0,.452-.735L2.689.324,2.955.232l1.353.83a1.212,1.212,0,0,0,.838.2,1.33,1.33,0,0,0,.78-.4L7.089-.291a1.33,1.33,0,0,0,.4-.78,1.212,1.212,0,0,0-.2-.838L6.441-3.254l.1-.249,1.552-.365a1.27,1.27,0,0,0,.73-.457A1.291,1.291,0,0,0,9.1-5.146V-6.79a1.291,1.291,0,0,0-.274-.822,1.27,1.27,0,0,0-.73-.457L6.558-8.442,6.45-8.708,7.3-10.052a1.2,1.2,0,0,0,.2-.834,1.365,1.365,0,0,0-.4-.784L5.935-12.833a1.312,1.312,0,0,0-.772-.39,1.236,1.236,0,0,0-.838.191l-1.353.83-.282-.108-.357-1.552a1.278,1.278,0,0,0-.452-.73,1.286,1.286,0,0,0-.826-.274H-.623a1.286,1.286,0,0,0-.826.274,1.278,1.278,0,0,0-.452.73l-.365,1.552-.282.108-1.345-.83a1.257,1.257,0,0,0-.843-.191,1.347,1.347,0,0,0-.776.39l-1.154,1.162a1.324,1.324,0,0,0-.4.784,1.223,1.223,0,0,0,.2.834l.838,1.345-.1.266-1.536.374a1.255,1.255,0,0,0-.735.457,1.3,1.3,0,0,0-.27.822v1.644a1.291,1.291,0,0,0,.274.822,1.27,1.27,0,0,0,.73.457l1.552.365.091.249-.838,1.345a1.23,1.23,0,0,0-.2.838,1.291,1.291,0,0,0,.4.78L-5.5.863a1.33,1.33,0,0,0,.78.4,1.241,1.241,0,0,0,.847-.2l1.345-.83.266.091L-1.9,1.876a1.263,1.263,0,0,0,.452.735A1.3,1.3,0,0,0-.623,2.88ZM-.49,1.585A.215.215,0,0,1-.73,1.395l-.5-2.059A4.648,4.648,0,0,1-1.955-.9a4.316,4.316,0,0,1-.61-.311L-4.375-.1a.22.22,0,0,1-.307-.042l-.979-.979a.23.23,0,0,1-.033-.307l1.112-1.793q-.141-.266-.291-.606a4.82,4.82,0,0,1-.249-.722l-2.059-.49a.215.215,0,0,1-.191-.241V-6.666a.222.222,0,0,1,.191-.241l2.05-.5a4.112,4.112,0,0,1,.261-.755l.27-.581-1.1-1.793a.247.247,0,0,1,.025-.324l.988-.963a.254.254,0,0,1,.315-.042l1.793,1.087a5.849,5.849,0,0,1,.627-.3,5.886,5.886,0,0,1,.735-.249l.49-2.059a.215.215,0,0,1,.241-.191H.921a.2.2,0,0,1,.232.191l.506,2.075a4.86,4.86,0,0,1,.726.245q.336.145.61.295l1.8-1.1a.264.264,0,0,1,.324.042l.979.963a.235.235,0,0,1,.025.324l-1.1,1.793q.116.232.274.581a4.325,4.325,0,0,1,.257.755l2.059.5a.222.222,0,0,1,.191.241v1.386a.215.215,0,0,1-.191.241l-2.067.49a5.146,5.146,0,0,1-.245.722,6.226,6.226,0,0,1-.295.606L6.118-1.428a.219.219,0,0,1-.033.307l-.971.979A.23.23,0,0,1,4.8-.1L2.988-1.212A4.411,4.411,0,0,1,2.382-.9a4.505,4.505,0,0,1-.722.237L1.154,1.395a.2.2,0,0,1-.232.191ZM.216-2.822a3.049,3.049,0,0,0,1.59-.427A3.234,3.234,0,0,0,2.951-4.4a3.071,3.071,0,0,0,.427-1.594,3.034,3.034,0,0,0-.427-1.581A3.245,3.245,0,0,0,1.805-8.72a3.049,3.049,0,0,0-1.59-.427,3.049,3.049,0,0,0-1.59.427,3.279,3.279,0,0,0-1.15,1.146,3.011,3.011,0,0,0-.432,1.581A3.027,3.027,0,0,0-2.523-4.4a3.314,3.314,0,0,0,1.15,1.15A3.027,3.027,0,0,0,.216-2.822Zm0-1.287a1.815,1.815,0,0,1-.942-.253,1.91,1.91,0,0,1-.681-.681,1.83,1.83,0,0,1-.253-.95,1.793,1.793,0,0,1,.253-.938,1.921,1.921,0,0,1,.681-.677,1.815,1.815,0,0,1,.942-.253,1.778,1.778,0,0,1,.93.253,1.932,1.932,0,0,1,.677.677,1.793,1.793,0,0,1,.253.938,1.815,1.815,0,0,1-.253.942,1.955,1.955,0,0,1-.677.685A1.756,1.756,0,0,1,.216-4.109Z" transform="translate(8.666 14.867)" fill="#052b58"/></svg>
              <br />
              Admin
            </router-link>
          </div> <!-- /.col -->
          <div class="col">
            <router-link to="/account" class="nav-tab" exact-active-class="active">
              <!-- <img src="../assets/img/tab-icon-profile.svg" alt="smiley" width="17px" height="17px"> -->
              <svg xmlns="http://www.w3.org/2000/svg" width="16.934" height="16.934" viewBox="0 0 16.934 16.934"><path d="M.216,2.474A8.122,8.122,0,0,0,3.482,1.81a8.655,8.655,0,0,0,2.7-1.834,8.655,8.655,0,0,0,1.834-2.7,8.122,8.122,0,0,0,.664-3.266A8.122,8.122,0,0,0,8.019-9.26a8.655,8.655,0,0,0-1.834-2.7A8.641,8.641,0,0,0,3.478-13.8,8.151,8.151,0,0,0,.208-14.46a8.122,8.122,0,0,0-3.266.664,8.6,8.6,0,0,0-2.7,1.834,8.69,8.69,0,0,0-1.83,2.7,8.122,8.122,0,0,0-.664,3.266,8.122,8.122,0,0,0,.664,3.266,8.655,8.655,0,0,0,1.834,2.7,8.655,8.655,0,0,0,2.7,1.834A8.122,8.122,0,0,0,.216,2.474Zm0-1.411A6.9,6.9,0,0,1-2.532.515,7.1,7.1,0,0,1-4.777-1,7.041,7.041,0,0,1-6.288-3.246a6.946,6.946,0,0,1-.544-2.748,6.946,6.946,0,0,1,.544-2.748,7.124,7.124,0,0,1,1.507-2.25A6.959,6.959,0,0,1-2.54-12.505a6.946,6.946,0,0,1,2.748-.544,6.946,6.946,0,0,1,2.748.544A7.056,7.056,0,0,1,5.2-10.99a7.113,7.113,0,0,1,1.519,2.25,6.9,6.9,0,0,1,.548,2.748,6.946,6.946,0,0,1-.544,2.748A7.041,7.041,0,0,1,5.217-1,7.085,7.085,0,0,1,2.968.515,6.93,6.93,0,0,1,.216,1.063Zm-3.8-2.855H4a.452.452,0,0,0,.369-.145.572.572,0,0,0,.12-.378A2.179,2.179,0,0,0,4.229-3.2a4.208,4.208,0,0,0-.789-1.087A4.422,4.422,0,0,0,2.108-5.2a4.481,4.481,0,0,0-1.9-.374,4.481,4.481,0,0,0-1.9.374,4.422,4.422,0,0,0-1.332.917A4.208,4.208,0,0,0-3.814-3.2a2.179,2.179,0,0,0-.261.884.572.572,0,0,0,.12.378A.452.452,0,0,0-3.586-1.793ZM.208-6.259a1.918,1.918,0,0,0,1.075-.3,2.222,2.222,0,0,0,.772-.834,2.454,2.454,0,0,0,.286-1.191,2.322,2.322,0,0,0-.286-1.141,2.273,2.273,0,0,0-.772-.83,1.951,1.951,0,0,0-1.075-.311,1.951,1.951,0,0,0-1.075.311,2.273,2.273,0,0,0-.772.83,2.322,2.322,0,0,0-.286,1.141A2.43,2.43,0,0,0-1.639-7.4a2.23,2.23,0,0,0,.772.83A1.97,1.97,0,0,0,.208-6.259Z" transform="translate(8.251 14.46)" fill="#052b58"/></svg>
              <br />
              profile
            </router-link>
          </div> <!-- /.col -->
        </div> <!-- /.row -->
      </div> <!-- /.container -->
    </div> <!-- /.header-private -->

  </div> <!-- /.layout-private -->
</template>

<script>
import Vue from 'vue'
import {mapGetters} from 'vuex'

export default {
  props: ['customer', 'pageTitle', 'showBackBtn', 'showShareBtn', 'showCancelBtn'],
  data () {
    return {

    }
  },
  computed: {
    ...mapGetters(['user', 'user_props', 'custom_claims']),
  },
  methods: {
    goBack() {
      this.$emit('back');
    },
    logOut () {
      this.$firebase.logOut()
    },
  },
  mounted () {

  },
}
</script>

<style lang="less" scoped>
@import "../assets/less/variables.less";

.layout-private {
  height: 100%;
  margin: 0; // override row negative margins
  position: relative;
}
// Header elements
.header-private {
  height: 94px;
  box-shadow: 0 0 40px rgba(0,0,0,0.05);
  position: relative;
}
.row-title {
  height: 94px;

  p.title {
    margin-bottom: 13px;
    // font-size: 18px;
    // padding: 10px 5px;
  }
  .left-button,
  .right-button {
    width: 70px;
    margin-bottom: 10px;
  }
  .left-button {
    margin-left: 10px;
  }
  .right-button {
    margin-right: 10px;
  }
  .btn-icon {
    padding: 10px 5px;

    .far {
      font-size: 22px;
    }
  }

}
// body elements
.container-content {
  position: relative;
  overflow: hidden;
}
.col-content,
.row-content,
.col-content .container,
.col-override {
  height: 100%;
}
// remove position:relative from bootstrap .col class
.col-override {
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  overflow-y: scroll;
}
.col-content {
  // padding-top: 30px;
  overflow-y: scroll;
  position: relative // for button overlays
}
// footer elements
.footer-private {
  min-height: 83px; // prevent flex-grow-1 from shrinking it
  height: 83px;
  background-color: @light-color;
  box-shadow: 0 0 40px rgba(0,0,0,0.05);

  .row-tabs {
    .col {
      padding: 5px 10px 10px;
    }
    .nav-tab {
      font-size: 10px;
      line-height: 10px;
      color: #999999;
      text-decoration: none !important;

      svg path {
        fill: #999999;
      }
    }
    .nav-tab.active {
      color: @dark-color;

      svg path {
        fill: @dark-color;
      }
    }
  }
}
.instructions-restart {
  position: absolute;
  z-index: 3000;
  top: 0;
  background-color: #D3F5FF; // 50% @color-blue
  height: 100%;
  padding: 50px 20px;

  ol {
    padding: 0 0 0 1.5em;
    margin: 0;

    li {
      margin-bottom: 20px;
    }
  }
  .img-align-baseline {
    vertical-align: baseline;
    padding: 2px;
    border: 1px solid @dark-color;
    border-radius: 3px;
  }
}
</style>
